<template>
    <div class="pageBox">
        <div class="frame">
            <div class="box nav">
                <span>当前位置：</span>
                <router-link to="/">首页</router-link>
                &nbsp;>&nbsp;
                <router-link :to="{name:'SolutionList',params:{stId:solutionCateId1}}">{{ solutionCate1 }}</router-link>
                &nbsp;>&nbsp;
                <span>{{ bigTitle }}</span>
            </div>
        </div>
        <div class="box bigTitle">{{ bigTitle }}</div>
        <div class="box imgRow">
            <div class="imgBox">
                <img :src="newsImg" :alt="bigTitle">
            </div>
            <div class="infoBox">
                <div class="smallTitle">{{ smallTitle }}</div>
                <div class="info">{{ solutionInfo }}</div>
                <div class="ask">咨询报价</div>
            </div>
        </div>
        <div class="box detailRow" v-html="solutionDetail"></div>
        <div class="ListBox" v-show="hot.length>0">
            <span class="hot">热门推荐</span>
            <div class="ListFrame">
                <router-link
                    :to="{name:'SolutionDetail',params:{sId:item.id}}"
                    class="item"
                    v-for="(item,index) in hot"
                    :key="index">
                    <div class="imgBox">
                        <img :src="item.serviceImg" :alt="item.title">
                    </div>
                    <div class="name">{{ item.title }}</div>
                    <div class="info">{{ item.subTitle }}</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "solutionDetail",
    data() {
        return {
            solutionCate1: '解决方案',
            solutionCateId1: 0,
            solutionCate2: '',
            solutionCate3: '',
            bigTitle: '',
            smallTitle: '',
            solutionInfo: '',
            solutionDetail: '',
            newsImg: '',
            hot: []
        }
    },
    mounted() {
        this.$store.commit('setNav', 6)
        this.getSolutionDetail(this.$route.params.sId)
    },
    watch: {
        '$route.params.sId'() {
            this.getSolutionDetail(this.$route.params.sId)
        }
    },
    methods: {
        /**
         * 获取解决方案详情
         */
        getSolutionDetail(id) {
            this.$post('/V1/SolutionType/GetServiceTypeDetail',
                {
                    "serviceId": id
                })
                .then((res) => {
                    // console.log('detail', res)
                    if (res.success) {
                        this.solutionDetail = res.response.content
                        this.solutionInfo = res.response.info
                        this.newsImg = res.response.serviceImg
                        this.bigTitle = res.response.title
                        this.smallTitle = res.response.subtitle
                        this.solutionCateId1 = res.response.serviceTypeId
                        this.hot = res.response.recommands
                        this.solutionCate1 = res.response.serivceTypeName
                        document.title = this.bigTitle + this.$suffix
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        }
    }
}
</script>

<style scoped lang="less">

.pageBox {
    .frame {
        width: 100%;
        background-color: #f9f9f9;
    }

    .box {
        width: 1210px;
        margin: 0 auto;
    }

    .nav {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #666666;
        font-size: 16px;
        height: 40px;
        line-height: 40px;

        a{
            color: #666;
        }
    }

    .bigTitle {
        font-weight: bold;
        font-size: 24px;
        color: #333;
        padding: 20px 0px;
    }

    .imgRow {
        display: flex;
        flex-direction: row;
        padding-bottom: 50px;

        .imgBox {
            width: 420px;
            height: 210px;
            overflow: hidden;
            box-shadow: 0px 0px 6px 0px #eeeeee;
            margin-right: 40px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .infoBox {
            display: flex;
            flex-direction: column;

            .smallTitle {
                font-size: 18px;
                color: #333;
                font-weight: bold;
                margin-bottom: 20px;
            }

            .info {
                font-size: 16px;
                color: #333;
                margin-bottom: 20px;
            }

            .ask {
                color: white;
                background-color: #1f2d5c;
                border-radius: 5px;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
            }
        }
    }

    .detailRow {
        overflow: hidden;
        padding-bottom: 40px;

        img, table {
            max-width: 100%;
        }
    }

    .ListBox {
        width: 1210px;
        margin: 40px auto 20px;
        display: flex;
        flex-direction: column;

        .hot {
            color: #1f2d5c;
            font-size: 18px;
            padding: 0px 20px;
            font-weight: bold;
        }

        .ListFrame {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: 20px;
                width: 249px;
                height: 249px;
                background-color: white;
                margin-top: 15px;
                margin-bottom: 10px;
                margin-right: 18px;
                border-radius: 5px;

                .imgBox {
                    width: 250px;
                    height: 125px;
                    overflow: hidden;
                    border: 1px solid #cccccc;
                    margin-bottom: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .name {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #1f2d5c;
                    font-size: 18px;
                    max-width: 100%;
                    margin-bottom: 20px;
                    height: 24px;
                }

                .info {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: #999;
                    font-size: 15px;
                    max-width: 100%;
                    margin-bottom: 10px;
                    height: 20px;
                }

                .addCart {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    color: #f1f1f1;
                    font-size: 15px;
                    background-color: #1f2d5c;
                    padding: 10px 14px;
                    border-radius: 10px;
                    cursor: pointer;

                    img {
                        margin-left: 5px;
                    }
                }
            }

            .item:nth-child(4n) {
                margin-right: 0;
            }

            .item:hover {
                box-shadow: 0px 0px 8px #474d5e;
                margin-top: 1px;
                margin-bottom: 24px;
                transition: .4s;
            }
        }
    }
}
</style>
